<template lang="pug">
  SingleLayout(
    :item='true'
  )
    template(
      slot='item'
    )
      PlaylistEditor(
        v-if='playlist'
        :playlist='playlist'
      )
</template>

<script>
import { mapGetters } from "vuex";

import l10n from "@/services/l10n";
import PlaylistEditor from "@/components/Editor/PlaylistEditor";
import PageLoader from "@/services/pageLoader";
import errorHandler from "@/services/errorHandler";
import singlePage from "@/mixins/pages/single.mixin";

const strategy = async function(route, ctx) {
  try {
    const id = PageLoader.getIdFromRoute(route);
    const { playlist } = await PageLoader.getPlaylist({ id });

    ctx._playlist = playlist;
    ctx.playlistId = id;
    route.meta.title = l10n("EDITING_PLAYLIST");
  } catch (error) {
    errorHandler.resolve(error);
  }

  try {
    await PageLoader.getTracks({ ids: ctx._playlist.tracks });
  } catch (error) {
    errorHandler.add(error);
  }
};

export default {
  name: "PlaylistEdit",
  data() {
    return {
      playlistId: null
    };
  },
  mixins: [singlePage(strategy)],
  computed: {
    ...mapGetters({
      playlists: "playlists/playlists"
    }),
    playlist() {
      return this.playlists[this.playlistId];
    }
  },
  components: {
    PlaylistEditor
  }
};
</script>
